<template>
  <div>
    <b-table-simple v-if="data" bordered small responsive class="bg-white">
      <b-tbody>
        <b-tr>
          <b-th
            rowspan="3"
            class="w-25"
            v-text="pathOr(null, ['caption'], data)"
          />
          <b-td class="w-25">درجه قوت شایستگی</b-td>
          <b-td
            class="text-center progress-td"
            :class="{ 'bg-green': pathOr(0, ['desirability'], data) }"
            :style="`width: ${tdWidthStyle('desirability')}%`"
            v-text="`${pathOr(0, ['desirability'], data)}%`"
          />
        </b-tr>
        <b-tr>
          <b-td class="w-25">ریسک</b-td>
          <b-td
            class="text-center progress-td"
            :class="{ 'bg-red': pathOr(0, ['risk'], data) }"
            :style="`width: ${tdWidthStyle('risk')}%`"
            v-text="`${pathOr(0, ['risk'], data)}%`"
          />
        </b-tr>
        <b-tr>
          <b-td class="w-25">بازده انتظاری</b-td>
          <b-td
            class="text-center progress-td"
            :class="{ 'bg-blue': pathOr(0, ['efficiency'], data) }"
            :style="`width: ${tdWidthStyle('efficiency')}%`"
            v-text="`${pathOr(0, ['efficiency'], data)}%`"
          />
        </b-tr>
      </b-tbody>
    </b-table-simple>
  </div>
</template>

<script>
import { pathOr } from "ramda";

export default {
  name: "percent-table",
  props: {
    data: {
      type: Object,
      default: null,
    },
  },
  methods: {
    pathOr,
    generateBackground(percent = 0) {
      const style = "";
    },
    tdWidthStyle(key) {
      const width = pathOr(0, [key], this.data);
      return width > 0 ? width : 100;
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  border-color: #966717 !important;
}
tr {
  border: 1px solid #966717;
  background-color: white !important;
}
.progress-td-default {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}
.progress-td {
  background-color: transparent;
  // position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black;
  font-weight: bold;
  border: none;
}
.bg-blue {
  background-color: #2f75b5 !important;
}
.bg-green {
  background-color: #00b050 !important;
}
.bg-red {
  background-color: #ff0000 !important;
}
</style>
